import type { CSSProperties } from "react";

import { getInitials } from "@/utils/initials";
import "./Avatar.css";

type Size = "xs" | "sm" | "md" | "lg";

type Props = {
  name?: string;
  initials?: string;
  size?: Size;
  background?: string;
  color?: string;
  title?: string;
};

const DEFAULT_BG = "linear-gradient(135deg,#FFD96B,#F4CC04)";

export function Avatar({ name, initials, size = "md", background, color, title }: Props) {
  const text = initials ?? getInitials(name);
  const style: CSSProperties = { background: background ?? DEFAULT_BG, color: color ?? "#011D33" };
  return (
    <span className={`avatar avatar-${size}`} style={style} title={title ?? name}>
      {text}
    </span>
  );
}
